import React from "react";

class List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            unordered: false,
            ordered: false
        }
    }

    render() {
        const {postFix } = this.props
        const onChange = ( key ) => {
            this.setState({
                ...this.state,
                [key]: this.state[key] ? false : true
            }, () => {
                this.props.onChange( key, this.state[key] );
            })
        }

        return (
            <div id={`comment-list-${postFix}`} class="toolbar-buttons text-format-buttons">
                <ul>
                    <li>
                        <a onClick={ () => onChange('unordered') } class={ this.props.currentState.listType === "unordered" ? "active" : "" }>
                            <i class="material-icons">format_list_bulleted</i>
                        </a>
                    </li>
                    <li>
                        <a onClick={ () => onChange('ordered') } class={ this.props.currentState.listType === "ordered" ? "active" : "" }>
                            <i class="material-icons">format_list_numbered</i>
                        </a>
                    </li>
                </ul>
            </div>
        );
    }
}

export default List;